webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuefire = __webpack_require__(17);
	
	var _vuefire2 = _interopRequireDefault(_vuefire);
	
	var _App = __webpack_require__(12);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuefire2.default);
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Hello = __webpack_require__(13);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _firebase = __webpack_require__(8);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  apiKey: 'AIzaSyB3B6_lHNK5JXKNa8SIskj71aha6I9ZekA',
	  authDomain: 'vuefire-quickstart-demo.firebaseapp.com',
	  databaseURL: 'https://vuefire-quickstart-demo.firebaseio.com',
	  storageBucket: 'vuefire-quickstart-demo.appspot.com',
	  messagingSenderId: '248222879987'
	};
	
	var app = _firebase2.default.initializeApp(config);
	var db = app.database();
	
	var greetingsRef = db.ref('greetings');
	
	exports.default = {
	  name: 'app',
	
	  firebase: {
	    greetings: greetingsRef.limitToLast(5)
	  },
	
	  data: function data() {
	    return {
	      newGreeting: {
	        lang: '',
	        text: ''
	      }
	    };
	  },
	
	  methods: {
	    addGreeting: function addGreeting() {
	      greetingsRef.push(this.newGreeting);
	      this.newGreeting.lang = '';
	      this.newGreeting.text = '';
	    }
	  },
	
	  components: {
	    Hello: _Hello2.default
	  }
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'hello',
	  data: function data() {
	    return {
	      msg: 'Welcome to Your Vue.js App'
	    };
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.693c090.png";

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(5)
	
	/* script */
	__vue_exports__ = __webpack_require__(2)
	
	/* template */
	var __vue_template__ = __webpack_require__(15)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(4)
	
	/* script */
	__vue_exports__ = __webpack_require__(3)
	
	/* template */
	var __vue_template__ = __webpack_require__(14)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-20045d9c"
	
	module.exports = __vue_exports__


/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hello"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "https://vuejs.org",
	      "target": "_blank"
	    }
	  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://forum.vuejs.org",
	      "target": "_blank"
	    }
	  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://gitter.im/vuejs/vue",
	      "target": "_blank"
	    }
	  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://twitter.com/vuejs",
	      "target": "_blank"
	    }
	  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://vuejs-templates.github.io/webpack/",
	      "target": "_blank"
	    }
	  }, [_vm._v("Docs for This Template")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "http://router.vuejs.org/",
	      "target": "_blank"
	    }
	  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://vuex.vuejs.org/",
	      "target": "_blank"
	    }
	  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://vue-loader.vuejs.org/",
	      "target": "_blank"
	    }
	  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://github.com/vuejs/awesome-vue",
	      "target": "_blank"
	    }
	  }, [_vm._v("awesome-vue")])])])
	}]}

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(11),
	      "height": "150px"
	    }
	  }), _vm._v(" "), _c('form', {
	    attrs: {
	      "id": "form"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.addGreeting($event)
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newGreeting.lang),
	      expression: "newGreeting.lang"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Language Name"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newGreeting.lang)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newGreeting.lang = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newGreeting.text),
	      expression: "newGreeting.text"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "How do you say hello?"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newGreeting.text)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newGreeting.text = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "Add Greeting"
	    },
	    domProps: {
	      "value": "Add Greeting"
	    }
	  })]), _vm._v(" "), _vm._l((_vm.greetings), function(greeting) {
	    return _c('h1', [_vm._v(_vm._s(greeting.text))])
	  })], 2)
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.40de853e31832a25bc15.js